"use client";
import { useEffect, useState } from "react";
import { useLanguage } from "@/app/utils/LanguageContext";
import {
    getAssetPrefix,
    getCurrentTimeFormatted,
    adobeData,
    getSearchParams,
} from "@/app/utils/Common";
import React from "react";
import "./index.scss"

const FinishPhotoForLocal = () => {
    if (typeof document !== 'undefined') {
        document.body.style.backgroundColor = "#003366";
    }

    const [imgSrc, setimgSrc] = useState('');
    const [img2Src, setimg2Src] = useState('');
    const [showErrorText, setshowErrorText] = useState('');
    const [isLine, setisLine] = useState(false);
    const assetPrefix = getAssetPrefix(); 
    const { path, raceimage, season, racedate } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));

    const getspeedmapIcon = (num: string) => {
        return `${assetPrefix}/images/finishlinephoto/speedmap_${num}.gif`;
    }
    const getspeedmapIcon_url = (num: string, noRepeat: boolean = false) => {
        return `url(${assetPrefix}/images/finishlinephoto/speedmap_${num}.gif) ${noRepeat? "no-repeat":""}`;
    }

    useEffect(() => {
        //finish-line-photo : ?path=//consvc.qcew.com/-/media/Sites/JCRW/FinishPhotos/23_24/20231213/20231213R01_P2.jpg

        // finish photo : ?raceImage=20231213R1_L.jpg&season=23_24&racedate=20231213
        if (path) {
            // finish line photo
            setisLine(true);
            // setimgSrc(`${assetPrefix}/images/finishlinephoto/20231213R01_P2.jpg`);
            setimgSrc(path);
        } else if (raceimage && season && racedate){
            // setimgSrc(`${assetPrefix}/images/raceresult/20231213R1_L.png`);
            //forttesting
            const raceImages = raceimage.split(',');
            const firstRaceImage = raceImages[0];
            const secondRaceImage = raceImages.length > 1 ? raceImages[1] : '';

            setimgSrc(`/general/-/media/Sites/JCRW/RaceResult/${season}/${racedate}/${firstRaceImage}`);
            setimg2Src(secondRaceImage ? `/general/-/media/Sites/JCRW/RaceResult/${season}/${racedate}/${secondRaceImage}` : '');
        } else {
            setshowErrorText("Sorry ! Finish photo for this race is not ready !");
        }
    }, [])
    return <div style ={{
        backgroundColor: "#003366",
        margin:0
    }} className="FinishPhoto">
            <table  style={{width: 760, border: 0 }}  >
            <tbody>
                <tr style={{ verticalAlign: "top" }}>
                    <td style={{ width: 25, background: getspeedmapIcon_url("1c", true), height: 47 }}>
                        <img src={getspeedmapIcon("1a")} style={{ width: 25, height: 47}} />
                        </td>
                    <td style={{ width: 720, background: getspeedmapIcon_url("1c"), height: 47 }} >
                        <img src={getspeedmapIcon("1b")} style={{ width: 720, height: 47, float: "right" }} />
                        </td>
                    <td style={{ width: 26, background: getspeedmapIcon_url("1c", true), height: 47 }} >
                        <div style={{ textAlign: "right" }}>
                            <img src={getspeedmapIcon("1d")} style={{ width: 25, height: 47 }} />
                        </div>
                    </td>
                </tr>
                <tr >
                    <td style={{ width: 25, background: getspeedmapIcon_url("2a"), height: 602 }}  >
                    </td>
                    <td style={{ width: 720, height: 602, background: getspeedmapIcon_url("2b") }}  >
                        {!showErrorText && imgSrc ? <div style={{ display: "inline-flex", alignItems: "flex-start", whiteSpace: "nowrap", background:"white" }}>
                            <img style={{ textAlign: "right", cursor: "pointer", height: 602, border: "0" }} src={imgSrc} />
                            {img2Src ? <img style={{ textAlign: "right", cursor: "pointer", height: 602, border: "0", paddingLeft: "3px" }} src={img2Src} /> : null}
                        </div> :<p style={{height:20, lineHeight: '20px' }}>{showErrorText}</p> }
                    </td>
                    <td style={{ width: 26, height: 602, background: getspeedmapIcon_url("2c") }}  >
                        <div style={{ textAlign: "right" }}>
                        </div>
                    </td>
                </tr>
                <tr style={{ height: 6 }}>
                    <td style={{ width: 25 ,background: getspeedmapIcon_url("3a") }}>
                    </td>
                    <td style={{ width: 720, background: getspeedmapIcon_url("3b") }} >

                    </td>
                    <td style={{ width: 26, background: getspeedmapIcon_url("3d") }}>
                    </td>
                </tr>
                <tr style={{ height: 38 }}>
                    <td style={{ width: 25, background: getspeedmapIcon_url("4a") }}>
                    </td>
                    <td style={{ width: 720, background: getspeedmapIcon_url("2b") }}>
                    </td>
                    <td style={{ width: 26, background: getspeedmapIcon_url("4d") }}>
                    </td>
                </tr>
                <tr style={{ height: 7 }}>
                    <td style={{ width: 25, background: getspeedmapIcon_url("5b") }}>

                    </td>
                    <td style={{ width: 720, background: getspeedmapIcon_url("5b") }} >
                    </td>
                    <td style={{ width: 26, background: getspeedmapIcon_url("5b") }}>
                        <img src={getspeedmapIcon("5d")} style={{ width: 25, height: 7 }} />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
}

export default FinishPhotoForLocal